import commercial from './commercial'

export default { commercial }
